(function()  {

    'use strict';

    const Gallery = function (element) {

        // The gallery object itself
        this.element = element;

        /// The dialog modal of the gallery
        this.modal = element.getElementsByClassName('gallery__modal')[0];

        /// The grid view of the gallery
        this.grid = element.getElementsByClassName('gallery__thumbnails')[0];

        /// The keyboard trigger of the gallery
        this.trigger = element.getElementsByClassName('gallery__thumbnail')[0];

        // The main display within the gallery that shows the prominent image
        this.display = element.getElementsByClassName('modal__display')[0];

        /// The image path of the prominent image
        this.image = this.display.getElementsByTagName('IMG')[0];

        /// The alternative source of the prominent image
        this.source = this.display.getElementsByTagName('SOURCE')[0];

        // The container for all the thumbnails
        this.thumbnails = element.getElementsByClassName('modal__thumbnail');

        this.presentModal = this.presentModal.bind(this);
        this.swapImage = this.swapImage.bind(this);
        this.stealFocus = this.stealFocus.bind(this);
        this.dismissModal = this.dismissModal.bind(this);

        this.initiateListener();
    }

    /**
     * Starts listening
     */
    Gallery.prototype.initiateListener = function () {

        for (const thumbnail of this.thumbnails) {
            thumbnail.addEventListener('pointerdown', this.swapImage);
            thumbnail.addEventListener('focus', this.swapImage);
        }

        this.grid.addEventListener('pointerdown', this.presentModal);

        this.trigger.addEventListener('keydown', this.presentModal);

        this.modal.addEventListener('keydown', this.stealFocus);
    }

    /**
     * Swaps the image based on the selection
     */
    Gallery.prototype.swapImage = function(event) {

        const source = event.target.querySelector('source');
        const image = event.target.querySelector('img');

        this.image.src = image.src;
        this.image.alt = image.alt;

        if (source !== undefined && this.source !== undefined) {
            this.source.srcset = source.srcset;
        }
    }

    /**
     * Steals the focus to stay within the modal
     */
    Gallery.prototype.stealFocus = function (event) {

        if (event.key === 'Tab') {

            if (event.target === this.thumbnails[this.thumbnails.length - 1]) {

                event.preventDefault();

                this.thumbnails[0].focus();
            }
        }
    }

    /**
     * Shows the modal.
     */
    Gallery.prototype.presentModal = function (event) {

        let present = false;

        if (event.type === 'keydown' && event.key === 'Enter') {
            present = true;
        }

        if (event.type === 'pointerdown' && !this.modal.open && this.grid.contains(event.target) && this.grid !== event.target) {
            present = true;
        }

        if (present) {

            this.modal.showModal();

            window.addEventListener('pointerdown', this.dismissModal);
        }
    }

    /**
     * Dismiss the modal.
     */
    Gallery.prototype.dismissModal = function (event) {

        if (event.type === 'pointerdown' && this.modal.open && !event.target.closest('.js-gallery')) {

            this.modal.close();

            window.removeEventListener('pointerdown', this.dismissModal);
        }
    }

    const galleries = document.getElementsByClassName('js-gallery');

    for (const gallery of galleries) {
        new Gallery(gallery);
    }

}());